/**
 * Composant de chargement partagé
 */

import { CSSProperties } from 'react';

interface LoadingProps {
  text?: string;
  fullScreen?: boolean;
}

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px',
};

const fullScreenStyle: CSSProperties = {
  ...containerStyle,
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: '#f8fafc',
  zIndex: 9999,
};

const spinnerStyle: CSSProperties = {
  width: '40px',
  height: '40px',
  border: '4px solid #e2e8f0',
  borderTopColor: '#2563eb',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: '16px',
};

const textStyle: CSSProperties = {
  color: '#64748b',
  fontSize: '0.9rem',
};

export function Loading({ text = 'Chargement...', fullScreen = false }: LoadingProps) {
  return (
    <>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={fullScreen ? fullScreenStyle : containerStyle}>
        <div style={spinnerStyle} />
        <p style={textStyle}>{text}</p>
      </div>
    </>
  );
}
